export default (theme) => ({
    root: {
        position: 'relative',
        height: 80,
        width: 80,
        borderRadius: 4,
        border: `solid 1px ${theme.colors.grey[100]}`,
        marginRight: 14,
        '&:hover $delete': {
            display: 'flex',
        },
        '&:last-child': {
            marginRight: 24,
        },
    },
    img: {
        cursor: 'pointer',
        borderRadius: 4,
    },
    delete: {
        position: 'absolute',
        display: 'none',
        width: 32,
        height: 32,
        borderRadius: '50%',
        boxShadow: '0 3px 8px 0 rgba(0, 0, 0, 0.25)',
        top: -16,
        left: 24,
        background: theme.colors.primary.white,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '& path': {
            fill: theme.colors.grey[200],
            transition: '.2s',
        },
        '&:hover path': {
            fill: theme.colors.actionMinor[500],
        },
    },
});
